import React, { useEffect, useRef, useState } from 'react';
import { useIsOverflow } from '../../../hooks/useIsOverflow';
import './PollTitle.scss';

interface PollTitleProps {
    key: React.Key | null | undefined;
}

const PollTitle = (
    props: React.PropsWithChildren<PollTitleProps>,
): JSX.Element => {
    const ref = useRef<HTMLHeadingElement>(null);
    const isOverflow = useIsOverflow(ref);
    const [titleFontSize, setTitleFontSize] = useState(13);

    useEffect(() => {
        if (isOverflow) {
            setTitleFontSize(11);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOverflow]);

    return (
        <h2 ref={ref} className={`poll-title-${titleFontSize}`}>
            {props.children}
        </h2>
    );
};

export default PollTitle;
